import { ProcessCanceled } from "../../util/CustomErrors";
import { truthy } from "../../util/util";
import { log } from "../../util/log";
import { getExecGameVersion } from "./util/getGameVersion";
import { unknownToError } from "@vortex/shared";
export default class GameVersionManager {
    mApi;
    mProviders;
    constructor(api, providers) {
        this.mApi = api;
        this.mProviders = providers;
    }
    async getSupportedProvider(game, discovery) {
        for (const provider of this.mProviders) {
            const isSupported = await provider.supported(game, discovery);
            if (isSupported) {
                return Promise.resolve(provider);
            }
        }
    }
    async getGameVersion(game, discovery) {
        if (!this.isGameValid(game, discovery)) {
            return Promise.reject(new ProcessCanceled("Game is not discovered"));
        }
        const provider = await this.getSupportedProvider(game, discovery);
        try {
            const version = await provider.getGameVersion(game, discovery);
            return Promise.resolve(version);
        }
        catch (unknownErr) {
            const err = unknownToError(unknownErr);
            // fallback
            log("warn", "extension getGameVersion call failed", {
                message: err.message,
                stack: err.stack,
                extension: game.extensionPath,
            });
            return getExecGameVersion(game, discovery);
        }
    }
    isGameValid(game, discovery) {
        return (discovery?.path !== undefined &&
            truthy(game?.executable?.(discovery.path)));
    }
}
